export const MODULE = 'BPLS';
export const LIST = `${MODULE}/list`;
export const ITEM = `${MODULE}/item`;
export const TOGGLE_ASSESSMENT = `${MODULE}/toggle_assessment`;
export const GENERATE_BIN = `${MODULE}/genearate_bin`;
export const INITIAL_COMPUTATION = `${MODULE}/initial_computation`;
export const UPDATE_FEES = `${MODULE}/update_fees`;
export const CALCULATION = `${MODULE}/calculation`;
export const UPDATE_CALCULATION = `${MODULE}/update_calculation`;
export const SELECTED_CALCULATION = `${MODULE}/selected_calculation`;
export const FINAL_COMPUTATION = `${MODULE}/final_compuntation`;
export const APPROVE = `${MODULE}/approve`;
export const REJECT = `${MODULE}/reject`;
export const RELEASE = `${MODULE}/release`;
export const APPROVE_OWNERSHIP = `${MODULE}/approve_ownership`;
export const FORWARD_TO_LICENSE = `${MODULE}/forward_to_license`;

export const UPDATE_APPLICATION = `${MODULE}/update_application`;
export const CHANGE_APPLICATION = `${MODULE}/change_application`;
export const GET_BUSINESS_ACTIVITY_LIST = `${MODULE}/get_business_activity_list`;
export const GET_BUSINESS_NATURES_LIST = `${MODULE}/get_business_natures_list`;
export const GET_BUSINESS_LINES_LIST = `${MODULE}/get_business_lines_list`;
export const GET_NECESSARY_FIELD_LIST = `${MODULE}/get_necessary_field_list`;
export const CREATE_BUSINESS_ACTIVITY = `${MODULE}/create_business_activity`;
export const UPDATE_BUSINESS_ACTIVITY = `${MODULE}/update_business_activity`;
export const REMOVE_BUSINESS_ACTIVITY = `${MODULE}/remove_business_activity`;
export const GENERATE_TRANSMITTAL = `${MODULE}/generate_transmittal`;
export const TOGGLE_LICENSE_ASSESSMENT = `${MODULE}/toggle_license_assessment`;
export const GENERATE_SOA = `${MODULE}/generate_soa`;
export const ADD_BUSINESS_REMARKS = `${MODULE}/add_business_remarks`;
export const UPDATE_CEDULA_AMOUNT = `${MODULE}/update_cedula_amount`;
export const UPDATE_BUSINESS_ACTIVITY_GROSS_AMOUNT = `${MODULE}/update_business_activity_gross_amount`;
export const GET_LOGS = `${MODULE}/get_logs`;
export const UPDATE_DELINQUENT_CALCULATION_DETAIL = `${MODULE}/update_delinquent_calculation_detail`;
export const GET_CODE_LIST = `${MODULE}/get_code_list`;
export const ADD_DELINQUENT_YEAR = `${MODULE}/add_delinquent_year`;
export const CANCEL_SOA = `${MODULE}/cancel_soa`;
export const RETIREMENT_APPLICATION = `${MODULE}/retirement_application`;
export const ASSESS_RETIREMENT_REQUEST = `${MODULE}/assess_retirement_request`;
export const CANCEL_APPLICATION = `${MODULE}/cancel_application`;
export const ASSESS_RENEW_APPLICATION = `${MODULE}/assess_renew_application`;
export const VALIDATE_BUSINESS_ACTIVITY = `${MODULE}/validate_business_activity`;
export const REVOKE_PERMIT = `${MODULE}/revoke_permit`;
export const RETURN_TO_PERMIT = `${MODULE}/return_to_permit`;
export const RECALCULATE_SOA = `${MODULE}/recalculate_soa`;
export const GET_TRANSMITTAL_LIST = `${MODULE}/get_transmittal_list`;
export const INQUIRE_PREVIOUS_OR = `${MODULE}/inquire_previous_or`;
export const UPLOAD_CTC = `${MODULE}/upload_ctc`;
export const GET_BILLING_LIST = `${MODULE}/get_billing_list`;
export const UPDATE_BILLING = `${MODULE}/update_billing`;
export const UPDATE_OR_DATE = `${MODULE}/update_or_date`;
export const PAYMENT_POSTING = `${MODULE}/payment_posting`;
export const UPDATE_BUSINESS_STATE = `${MODULE}/update_business_state`;
export const FORWARD_TO_ENDORSING_OFFICE = `${MODULE}/forward_to_endorsing_office`;
export const GET_ENDORSING_OFFICES_LIST = `${MODULE}/get_endorsing_offices_list`;
export const GET_ENDORSING_OFFICES = `${MODULE}/get_endorsing_offices`;
export const UPDATE_ENDORSING_OFFICE = `${MODULE}/update_endorsing_office`;
export const ENDORSING_OFFICE_APPROVE = `${MODULE}/endorsing_office_approve`;
export const ENDORSING_OFFICE_REJECT = `${MODULE}/endorsing_office_reject`;
export const GET_BUSINESS_NECESSARY_FIELD = `${MODULE}/get_business_necessary_field`;
export const FOR_PICK_UP = `${MODULE}/for_pick_up`;
export const ISSUED = `${MODULE}/issued`;
export const APPLY_DISCOUNT = `${MODULE}/apply_discount`;
export const UPDATE_REGISTRY_NUMBER = `${MODULE}/update_registry_number`;
export const ENDORSING_OFFICE_REMARKS = `${MODULE}/endorsing_office_remarks`;
export const REVOKE_BARANGAY_CLEARANCE = `${MODULE}/revoke_barangay_clearance`;
export const GET_CALCULATION_DETAILS_LIST = `${MODULE}/get_calculation_details_list`;
export const VALIDATE_BUSINESS = `${MODULE}/validate_business`;
export const GET_BARANGAY_DETAILS = `${MODULE}/get_barangay_details`;
export const GET_CHECK_BARANGAY_CLEARANCE = `${MODULE}/get_check_barangay_clearance`;
export const UPDATE_BARANGAY_CLEARANCE_NUMBER = `${MODULE}/update_barangay_clearance_number`;
export const GET_CALCULATION_DETAILS_BY_BARANGAY = `${MODULE}/get_calculation_details_by_barangay`;
export const GET_YEAR_LIST =  `${MODULE}/get_year_list`;
export const GET_ENDORSING_OFFICE_LIST = `${MODULE}/get_endorsing_office_list`;
export const GET_REPORT_ACCESS = `${MODULE}/get_report_access`;

export default {};

export const GET_VET_REGISTRATION_LIST =
  'GET_VET_REGISTRATION_LIST/get_vet_registration_list';

export const TRANSMITTAL =
  '/api/v1/bpls/administrator/transaction_histories/transmittal/view'; // transmittal
export const BPLS_E2E_URL =
  '/api/v1/bpls/administrator/transaction_histories/permits/{id}/preview_soa'; // new url
export const BPLS_E2E_EOR_URL =
  '/api/v1/bpls/administrator/transaction_histories/permits/{id}/preview_or'; // e-or
export const BPLS_E2E_EPERMIT_URL =
  '/api/v1/bpls/administrator/transaction_histories/permits/{id}/preview_permit'; // e-permit
export const BPLS_E2E_EAPPLICATION_URL =
  '/api/v1/bpls/administrator/transaction_histories/permits/{id}/preview_application';
export const BPLS_E2E_PREVIOUS_EOR_URL =
  '/api/v1/bpls/administrator/transaction_histories/permits/{id}/preview_previous_or';
export const BPLS_E2E_ANNUAL_ESOA_URL =
  '/api/v1/bpls/administrator/transaction_histories/permits/{id}/preview_annual_soa'; // annual e-soa

export const TBPLS_URI =
  'api/temp/administrators/transaction_histories/ovr/{id}/soa';
export const TBPLS_URI_GENERATE =
  'api/temp/administrators/transaction_histories/business_permit/{id}/preview_soa';
export const TBPLS_OR_URI_GENERATE =
  'api/temp/administrators/transaction_histories/business_permit/{id}/preview_or';
export const TBPLS_PERMIT_URI_GENERATE =
  'api/temp/administrators/transaction_histories/business_permit/{id}/preview_permit';

export const GET_TRANSACTION_COUNTS = 'TRANSACTION/get_transaction_counts';

export const GET_REGION = `${MODULE}/get_regions`;
export const GET_PROVINCE = `${MODULE}/get_provinces`;
export const GET_MUNICIPALITIES = `${MODULE}/get_municipalities`;
export const GET_BARANGAYS = `${MODULE}/get_barangays`;
export const GET_CITIZENSHIP = `${MODULE}/get_citizenship`;

export const CALLBACK_TIMER = 'CALLBACK_TIMER/callback_timer';

// manual posting
export const MANUAL_PAYMENT_POSTING = 'TRANSACTION/manual_payment_posting';

export const FORM_DATA = {
  name: '',
  kind_of_ownership: '',
  bin: '',
  tin_no: '',
  dti_no: '',
  sec_no: '',
  cellphone_no: '',
  telephone_no: '',
  area_of_business_establishment: '',
  no_of_employees: '',
  taxpayer_id: '',
  region_code: '130000000',
  province_code: '133900000',
  municipality_code: '',
  barangay_code: '',
  street: '',
  capital_amount: '',
  gross_amount: '',
};

export const FORM_DATA_REMARKS = {
  remarks: '',
};

export const KIND_OF_OWNERSHIP = [
  { label: 'COOPERATIVE', value: 'COOPERATIVE' },
  { label: 'CORPORATION', value: 'CORPORATION' },
  { label: 'ONE PERSON CORPORATION', value: 'ONE PERSON CORPORATION' },
  { label: 'PARTNERSHIP', value: 'PARTNERSHIP' },
  { label: 'SOLE PROPRIETORSHIP', value: 'SOLE PROPRIETORSHIP' },
];

export const OWNERS_GENDER = [
  { label: 'Female', value: 'F' },
  { label: 'Male', value: 'M' },
];

export const YES_NO = [
  { label: 'Yes', value: 1 },
  { label: 'No', value: 0 },
];

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR', value: 'JR' },
  { label: 'SR', value: 'SR' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
  { label: 'XI', value: 'XI' },
  { label: 'XII', value: 'XII' },
  { label: 'XIII', value: 'XIII' },
  { label: 'XIV', value: 'XIV' },
  { label: 'XV', value: 'XV' },
  { label: 'XVI', value: 'XVI' },
  { label: 'XVII', value: 'XVII' },
  { label: 'XVIII', value: 'XVIII' },
  { label: 'XIX', value: 'XIX' },
  { label: 'XX', value: 'XX' },
];

export const INIT_FORM_STATE = {
  bin: '',
  area: '',
  floor_area: '',
  base_line: '',
  no_of_male_employees: '',
  no_of_female_employees: '',
  no_of_employees: '',
  no_of_employees_residing_manila: '',
  no_of_van: '',
  no_of_truck: '',
  no_of_motorcycle: '',
  region_code: '',
  province_code: '',
  municipality_code: '',
  barangay_code: '',
  street: '',
  zip_code: '',
  location_owned: 0,
  with_tax_incentives: 0,
  tdn_no: '',
  pin_no: '',
  tax_incentives_attachment_url: '',
  kind_of_ownership: '',
  owners_gender: '',
  tin_no: '',
  // dti_no: '',
  sec_no: '',
  // cda_no: '',
  monthly_rental: '',
  business_name: '',
  trade_name: '',
  lessor_name: '',
  cellphone_no: '',
  telephone_no: '',
  email_address: '',
  nationality: '',
  incharge_last_name: '',
  incharge_first_name: '',
  incharge_middle_name: '',
  incharge_suffix_name: '',
  main_office_region_code: '',
  main_office_province_code: '',
  main_office_municipality_code: '',
  main_office_barangay_code: '',
  main_office_street: '',
  main_office_zip_code: '',
  activity_type: '',
  activity_type_others: '',
  pinned_geolocation: '',
  pin_selected: false,
  is_validated: '',

  // veterinary registration
  veterinary_fee_id: '',
  // calculation_details: {},
  activities: '',
  existing_activities: '',
  details: {},
};

export const BUSINESS_OPERATIONS_FIELD = [
  {
    key: 'area',
    label: 'Business Area (sq.m)',
    disabled: true,
    decimalScale: 0,
  },
  {
    key: 'floor_area',
    label: 'Total Floor Area (sq.m)',
    disabled: true,
    decimalScale: 0,
  },
  {
    key: 'no_of_employees_residing_manila',
    label: 'Number of Employees residing within Area',
    disabled: false,
    decimalScale: 0,
  },
  {
    key: 'no_of_male_employees',
    label: 'Total Number of Male Employees',
    disabled: false,
    decimalScale: 0,
  },
  {
    key: 'no_of_female_employees',
    label: 'Total Number of Female Employees',
    disabled: false,
    decimalScale: 0,
  },
  {
    key: 'no_of_van',
    label: 'Number of Van Delivery Vehicle: (0 if not applicable)',
    disabled: false,
    decimalScale: 0,
  },
  {
    key: 'no_of_truck',
    label: 'Number of Truck Delivery Vehicle: (0 if not applicable)',
    disabled: false,
    decimalScale: 0,
  },
  {
    key: 'no_of_motorcycle',
    label: 'Number of Motorcycle Delivery Vehicle: (0 if not applicable)',
    disabled: false,
    decimalScale: 0,
  },
];
